import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import EmailIllustrationSrc from "images/keyservice/keyhousecontact.avif";
import Datepicker from "../flowbitereactcomponents/datepicker";

const Container = tw.div`relative bg-white`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto flex justify-center items-center`;

const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`
]);

// ✅ Rounded image styling here
const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`w-full h-full bg-center bg-cover rounded-full shadow-lg`,
]);

const TextContent = tw.div`lg:py-8 text-center md:text-left`;
const Subheading = tw(SubheadingBase)`text-center md:text-left text-[#3F62A3]`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-primary-500 text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-black`;

export default ({
  subheading = "Offerte aanvragen",
  heading = (
    <>
      Wil je een offerte aanvragen?{" "}
      <span className="text-primary-500">Neem nu contact op!</span>
    </>
  ),
  description = "Of je nu een offerte wilt aanvragen of meer informatie nodig hebt, wij helpen je graag verder. Kies een geschikte dienst en vraag eenvoudig jouw offerte hieronder aan.",
  textOnLeft = true,
}) => {
  return (
    <Container id="contact">
      <TwoColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {description && <Description>{description}</Description>}
            <Datepicker />
          </TextContent>
        </TextColumn>
        <ImageColumn>
          <Image imageSrc={EmailIllustrationSrc} />
        </ImageColumn>
      </TwoColumn>
    </Container>
  );
};
